@if (typeObj && typeObj.survey) {
    @if (closed) {
        <div>
            <div [innerHTML]="typeObj.survey.end_description"></div>
        </div>
    }
    <h1 class="detail__title mt-3">Enquête</h1>
    @if (typeObj.survey.answer && !changing) {
        <div>
            <p>
                Je hebt deze vragenlijst beantwoord op
                {{ typeObj.survey.answer.created_at | date: 'd MMMM yyyy, H:mm' }} uur. Hieronder zie je jouw
                antwoorden.
            </p>
            @for (question of typeObj.survey.questions; track question.hash) {
                <div>
                    <h6 class="mt-2">{{ question.question }}</h6>
                    Mijn antwoord:
                    @if (question.multiple) {
                        @for (
                            selectedOption of typeObj.survey.answer.answers[question.hash] | selectedOptions;
                            track selectedOption;
                            let last = $last
                        ) {
                            <span> {{ selectedOption }}{{ last ? '' : ', ' }} </span>
                        }
                    } @else {
                        {{ typeObj.survey.answer.answers[question.hash] }}
                        @if (
                            question.type === 'boolean-quantity' && typeObj.survey.answer.answers[question.hash] == 'Ja'
                        ) {
                            <div>
                                {{ question.quantityQuestion }}:
                                {{ typeObj.survey.answer.answers[question.hash + '-quantity'] }}
                            </div>
                        }
                    }
                </div>
            }
            @if (!closed) {
                <button mat-raised-button color="secondary" (click)="changing = true" class="mt-3">
                    Antwoorden aanpassen
                </button>

                <button class="ms-2" mat-raised-button color="primary" (click)="clearAnswers()">
                    Antwoorden wissen
                </button>
            }
        </div>
    }
    @if (form && changing && !closed) {
        <div [formGroup]="form" (submit)="submit()">
            @for (question of typeObj.survey.questions; track question.hash) {
                <h6 class="mt-2">{{ question.question }}</h6>
                @if (question.type === 'open') {
                    <div>
                        <mat-form-field class="w-100">
                            <input matInput type="text" [name]="question.hash" [formControlName]="question.hash" />
                        </mat-form-field>
                    </div>
                }
                @if (question.disabledAnswer) {
                    <div class="fst-italic mb-3">
                        Grijze opties zijn niet meer beschikbaar omdat het aantal van {{ question.limitCount }} bereikt
                        is.
                    </div>
                }
                @if (question.type === 'boolean' && question.limit && !question.disabledAnswer) {
                    <div class="fst-italic mb-3">
                        Er is {{ question.count }} van {{ question.limitCount }} benodigd gevuld.
                    </div>
                }
                @if (question.type === 'boolean-quantity') {
                    <mat-radio-group [formControlName]="question.hash">
                        <mat-radio-button value="Ja" class="d-block" [disabled]="question.disabledAnswer">
                            Ja
                            @if (question.disabledAnswer) {
                                (Niet meer beschikbaar omdat het maximum aantal is bereikt)
                            }
                        </mat-radio-button>
                        <mat-radio-button value="Nee" class="d-block mb-1">Nee</mat-radio-button>
                    </mat-radio-group>
                }
                @if (question.type === 'boolean-quantity' && form.get(question.hash)?.value === 'Ja') {
                    <mat-form-field class="w-100 mb-1">
                        <mat-label>{{ question.quantityQuestion }}</mat-label>
                        <input
                            matInput
                            type="text"
                            appDecimalInput
                            decimalInput="0"
                            [name]="question.hash"
                            formControlName="{{ question.hash }}-quantity" />
                        <mat-error [control]="form.get(question.hash + '-quantity')"></mat-error>
                        @if (question.limitCount) {
                            <mat-hint>
                                Er is {{ question.count }} van {{ question.limitCount }} benodigd gevuld.
                            </mat-hint>
                        }
                    </mat-form-field>
                }
                @if (question.type === 'score') {
                    <mat-radio-group [formControlName]="question.hash" class="d-block">
                        @for (score of Array(question.limitCount); track i; let i = $index) {
                            <mat-radio-button [value]="i + 1" class="me-2">{{ i + 1 }}</mat-radio-button>
                        }
                    </mat-radio-group>
                }
                @if (question.type === 'boolean') {
                    <mat-radio-group [formControlName]="question.hash">
                        <mat-radio-button value="Ja" class="d-block" [disabled]="question.disabledAnswer">
                            Ja
                        </mat-radio-button>
                        <mat-radio-button value="Nee" class="d-block">Nee</mat-radio-button>
                    </mat-radio-group>
                }
                @if (question.type === 'options') {
                    <div>
                        @if (question.disabledAnswers?.length > 0) {
                            <div class="fst-italic mb-3">
                                Grijze opties zijn gekozen door iemand anders en niet meer beschikbaar.
                            </div>
                        }
                        @if (!question.multiple) {
                            <mat-radio-group [formControlName]="question.hash">
                                @for (option of question.options; track option) {
                                    <mat-radio-button
                                        [value]="option"
                                        class="d-block"
                                        [disabled]="
                                            question.disabledAnswers && question.disabledAnswers.indexOf(option) !== -1
                                        ">
                                        {{ option }}
                                    </mat-radio-button>
                                }
                            </mat-radio-group>
                        }
                        @if (question.multiple) {
                            <div [formGroupName]="question.hash">
                                @for (option of question.options; track option) {
                                    <div>
                                        <mat-checkbox
                                            [formControlName]="option"
                                            [disabled]="
                                                question.disabledAnswers &&
                                                question.disabledAnswers.indexOf(option) !== -1
                                            ">
                                            {{ option }}
                                        </mat-checkbox>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                @if (form.dirty) {
                    <mat-error [control]="fc[question.hash]"></mat-error>
                }
            }
            <button mat-flat-button color="primary" (click)="submit()" [disabled]="submitting" class="mt-2">
                {{ submitting ? 'Versturen...' : 'Antwoorden versturen' }}
            </button>
        </div>
    }
    @if (typeObj.survey.end_date && !closed) {
        <div class="mt-2">
            <small> Deze enquête sluit {{ typeObj.survey.end_date | date: 'd MMM yyyy H:mm' }} </small>
        </div>
    } @else if (typeObj.survey.end_date && closed) {
        <div class="mt-2">
            <small> Deze enquête is gesloten op {{ typeObj.survey.end_date | date: 'd MMMM yyyy H:mm' }} </small>
        </div>
    }
}
